import GlobalSearchContainer from './containers/GlobalSearchContainer'

export default GlobalSearchContainer
